import { Node } from 'tiptap';
import { sinkListItem, splitToDefaultListItem, liftListItem } from 'tiptap-commands';

export default class TodoItem extends Node {
  // eslint-disable-next-line class-methods-use-this
  get name() {
    return 'todo_item';
  }

  // eslint-disable-next-line class-methods-use-this
  get defaultOptions() {
    return {
      nested: false,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  get view() {
    return {
      props: ['node', 'updateAttrs', 'view'],
      methods: {
        onChange() {
          this.updateAttrs({
            done: !this.node.attrs.done,
          });
        },
      },
      template: `
        <li :data-type="node.type.name" :id="node.attrs.id" :data-done="node.attrs.done.toString()" data-drag-handle>
          <span class="todo-checkbox" contenteditable="false" @click="onChange"></span>
          <div class="todo-content" ref="content" :contenteditable="view.editable.toString()"></div>
        </li>
      `,
    };
  }

  get schema() {
    return {
      attrs: {
        done: {
          default: false,
        },
        id: {
          default: null,
        },
      },
      draggable: true,
      content: this.options.nested ? '(paragraph|todo_list)+' : 'paragraph+',
      toDOM: node => {
        const { done, id } = node.attrs;

        return [
          'li',
          {
            'data-type': this.name,
            'data-done': done.toString(),
            id,
          },
          ['span', { class: 'todo-checkbox', contenteditable: 'false' }],
          ['div', { class: 'todo-content' }, 0],
        ];
      },
      parseDOM: [
        {
          priority: 51,
          tag: `[data-type="${this.name}"]`,
          getAttrs: dom => ({
            done: dom.getAttribute('data-done') === 'true',
            id: dom.getAttribute('id'),
          }),
        },
      ],
    };
  }

  keys({ type }) {
    return {
      Enter: splitToDefaultListItem(type),
      Tab: this.options.nested ? sinkListItem(type) : () => {},
      'Shift-Tab': liftListItem(type),
    };
  }
}



// WEBPACK FOOTER //
// ./src/includes/TodoItem.js